var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeRel4B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2641_6784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 47C36.9787 47 47.5 36.4787 47.5 23.5C47.5 10.5213 36.9787 0 24 0C11.0213 0 0.5 10.5213 0.5 23.5C0.5 36.4787 11.0213 47 24 47Z",
    fill: "#F2F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6217 25.5114C30.0539 26.1386 31.3408 27.0555 32.4012 28.2045C32.5619 28.3821 32.6533 28.6117 32.6586 28.8512V32.8109C32.6586 33.0734 32.5543 33.3252 32.3686 33.5109C32.183 33.6965 31.9312 33.8008 31.6687 33.8008H16.4899C16.2296 33.8008 15.9798 33.6983 15.7946 33.5155C15.6093 33.3327 15.5035 33.0843 15.5 32.8241V28.8644C15.5021 28.6203 15.5937 28.3855 15.7574 28.2045C16.8178 27.0555 18.1047 26.1386 19.5369 25.5114C20.9692 24.8843 22.5158 24.5605 24.0793 24.5605C25.6428 24.5605 27.1894 24.8843 28.6217 25.5114Z",
    fill: "#99396D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0786 23.2392C26.6299 23.2392 28.6982 21.171 28.6982 18.6196C28.6982 16.0683 26.6299 14 24.0786 14C21.5273 14 19.459 16.0683 19.459 18.6196C19.459 21.171 21.5273 23.2392 24.0786 23.2392Z",
    fill: "#99396D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2641_6784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeRel4B);
export default __webpack_public_path__ + "static/media/icone-rel-4B.1225cd0f8f3b822a40e650c3b745925e.svg";
export { ForwardRef as ReactComponent };